/**
 * Shared UI state for the AI chat widget.
 * Allows opening/closing the chat panel from anywhere in the app
 * (e.g. from the home page hero trigger).
 */

const isOpen = ref(false);

export const useChatUI = () => {
  const open = () => {
    isOpen.value = true;
  };

  const close = () => {
    isOpen.value = false;
  };

  const toggle = () => {
    isOpen.value = !isOpen.value;
  };

  return {
    isOpen: readonly(isOpen),
    open,
    close,
    toggle,
  };
};
